import { useEffect, useRef, useState } from "react";
import { AdviseLabels } from "../enums/MessageEnum";
import "../index.css"

export default function NormalNavbar(props){

    const navbarColorUp = "text-blue-500"
    const navbarColorDown = "text-blue-900"

    const [hoverElement, setHoverElement] = useState(0)

    const labelColorSelected = props.isInHero ? navbarColorUp : navbarColorDown

    const normalClass = `block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 
                        ${props.isInHero ? 'md:hover:text-blue-500' : 'md:hover:text-white-900'} md:p-0 dark:text-white 
                        ${props.isInHero ? 'md:dark:hover:text-blue-500' : 'md:dark:hover:text-white-900'} dark:hover:bg-gray-700 
                        dark:hover:text-blue-900 md:dark:hover:bg-transparent font-bold`;
    const selectedClass = `block py-2 px-3 text-white rounded md:bg-transparent 
                            ${props.isInHero ? 'md:text-blue-500' : 'md:text-blue-900'} md:p-0 dark:text-white ${props.isInHero ? 'md:dark:text-blue-500' : 'md:dark:text-blue-900'}
                            font-bold`;

    const [dropDownOpen, setDropDownOpen] = useState(false)
    const dropDownRef = useRef(null)

    const handleClickOutside = (event) => {
        if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
          setDropDownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    // eslint-disable-next-line
    }, []);

    return(
        <div className="hidden w-full md:block md:w-auto" id="navbar-default">
            <ul className={`font-medium flex flex-col p-4 md:p-0 mt-4 
                border md:flex-row  md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0`}
            >
                {
                    props.options.map(function(optionIndex, optionValue) {
                        if (optionValue !== props.options.length - 1)
                            return(
                                <li key={optionIndex + optionValue}>
                                    <a href={"#" + props.routes[optionValue]}
                                        className={props.selected === optionValue ? selectedClass : normalClass}
                                        style={{color: hoverElement !== optionValue && props.selected !== optionValue ? "white" : ""}}
                                        onClick={(e) => {
                                            props.manageClick(e, optionValue)
                                        }}
                                        onMouseEnter={() => {setHoverElement(optionValue)}}>
                                        {optionIndex}
                                    </a>
                                </li>
                            );
                        return(
                            <li ref={dropDownRef} key={optionIndex + optionValue}>
                                <button id="dropdownNavbarLink"
                                    className={`flex items-center justify-between w-full py-2 px-3 
                                    text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent 
                                    md:border-0 md:hover:${labelColorSelected} md:p-0 md:w-auto dark:text-white 
                                    md:dark:hover:${labelColorSelected} dark:focus:text-white 
                                    dark:border-gray-700 dark:hover:bg-gray-700 
                                    md:dark:hover:bg-transparent font-bold`}
                                    style={{color: hoverElement !== optionValue && props.selected !== optionValue ? "white" : ""}}
                                    onClick={() => {setDropDownOpen(!dropDownOpen)}}>
                                        {optionIndex}
                                        <svg className="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                        fill="none" viewBox="0 0 10 6">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                                            strokeWidth="2" d="m1 1 4 4 4-4"/>
                                        </svg>
                                </button>
                                {dropDownOpen ?
                                    <div className="help-dropdown z-10 font-normal bg-white divide-y
                                     divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700
                                     dark:divide-gray-600">
                                        <ul className="py-2 text-sm text-gray-700 dark:text-gray-400"
                                            ariaLabelledby="dropdownLargeButton">
                                            <li>
                                                <a
                                                    href="/assets/pdf/ADV_ProgramaIntegridad_v1.0.1.pdf"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="block px-4 py-2 hover:bg-gray-100
                                                 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    {AdviseLabels.HELP_PROGRAM}
                                                </a>
                                            </li>
                                        </ul>
                                        <ul className="py-2 text-sm text-gray-700 dark:text-gray-400"
                                            ariaLabelledby="dropdownLargeButton">
                                            <li>
                                                <a
                                                    href="/assets/pdf/RES_EXENTA_40_Horas.pdf"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="block px-4 py-2 hover:bg-gray-100
                                                 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    {AdviseLabels.SEAL_40_HRS}
                                                </a>
                                            </li>
                                        </ul>
                                        {
                                            
                                            <ul className="py-2 text-sm text-gray-700 dark:text-gray-400"
                                            ariaLabelledby="dropdownLargeButton">
                                            <li>
                                                <a
                                                    href="https://www.advise.cl/ConvenioMarco/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="block px-4 py-2 hover:bg-gray-100
                                                 dark:hover:bg-gray-600 dark:hover:text-white">
                                                    {AdviseLabels.HELP_CM}
                                                </a>
                                            </li>
                                        </ul>
                                    }    
                                    </div>
                                    : <></>}
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )

}